export default "__VITE_ASSET__CGG2vgAc__"